export default __webpack_public_path__ + "static/me-3a06ac10acd0d1e2c9b7a741584ed4f0.jpg";